import { render, staticRenderFns } from "./recommProduct.vue?vue&type=template&id=54d2c80a&scoped=true"
import script from "./recommProduct.vue?vue&type=script&lang=js"
export * from "./recommProduct.vue?vue&type=script&lang=js"
import style0 from "./recommProduct.vue?vue&type=style&index=0&id=54d2c80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2c80a",
  null
  
)

export default component.exports